export const TAB_TRANSACTIONS = 'Transactions'
export const TAB_RECEIVE = 'Receive'
export const TAB_SEND = 'Send'
export const TAB_SETTINGS = 'Settings'
export const TAB_UNLINK = 'Unlink'
export const TAB_RECOVER = 'Recover'
export const TAB_BACKUP = 'Backup'
export const TAB_CHANGE_PASSWORD = 'ChangePassword'
